import React from "react";
import CountUp from "react-countup";

import ClassIcon from "../../icons/class-icon";
import StaffIcon from "../../icons/staff-icon";
import StudentIcon from "../../icons/student-icon";
import TeacherIcon from "../../icons/teacher-icon";

const HeadLegendItem = ({ title, count, icon }) => {
  const renderIcon = () => {
    switch (icon) {
      case "class":
        return <ClassIcon />;
      case "employee":
        return <StaffIcon />;
      case "teacher":
        return <TeacherIcon />;
      case "student":
        return <StudentIcon />;
    }
  };
  return (
    <div className="head-legend">
      <div className="title">
        <i>{renderIcon()}</i>
        <p>{title}</p>
      </div>
      <div className="body">
        <h1>
          {count ? <CountUp end={parseInt(count)} duration={2.75} /> : "0"}
        </h1>
      </div>
    </div>
  );
};

export default HeadLegendItem;
